import statuses from 'statuses';
/**
 * Intercepts failed HTTP requests and validates if they failed because the server uses a different
 * version.
 * @ngesdoc service
 * @ngname appAPIVersionInterceptor
 * @ngmodule common
 */
class AppAPIVersionInterceptor {
  /**
   * @param {ngQ}          $q         To return a rejected promise.
   * @param {AppEvents}    appEvents  To trigger the event informing of the version being outdated.
   * @param {CommonEvents} APP_EVENTS To get the name of the event the service may trigger.
   */
  constructor($q, appEvents, APP_EVENTS) {
    'ngInject';

    /**
     * A local reference for the `$q` service.
     * @type {ngQ}
     */
    this.$q = $q;
    /**
     * A local reference for the `appEvents` service.
     * @type {AppEvents}
     */
    this.appEvents = appEvents;
    /**
     * A local reference for the `APP_EVENTS` constant.
     * @type {CommonEvents}
     */
    this.APP_EVENTS = APP_EVENTS;
    /**
     * Bind the method as it will be sent as an `$http` interceptor.
     * @ignore
     */
    this.responseError = this.responseError.bind(this);
  }
  /**
   * Intercepts a failed HTTP request response and validates if it failed because the app version
   * is oudated; if that's the case, it will trigger an event so the app can handle it.
   * @param {Object} response The response of the failed HTTP request.
   * @return {Promise<undefined,Error>}
   */
  responseError(response) {
    if (
      // If the HTTP status is 409.
      response.status === statuses('conflict') &&
      // If the body has a `data` property.
      response.data.data &&
      // If the `data` property has an `api` flag.
      response.data.data.api
    ) {
      // Emit the event.
      this.appEvents.emit(this.APP_EVENTS.outdated);
    }

    // Return the rejected promise to keep the flow.
    return this.$q.reject(response);
  }
}

export default AppAPIVersionInterceptor;
